import { useTranslation } from "react-i18next";
import React, { useState, useCallback, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import loadMaterialIcon from "../shared/functions/loadMaterialIcon";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import {
  Toolbar,
  Typography,
  Box,
  Button,
  Badge,
  ListItemButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { useSessionStorage } from "../../utils/hooks";
import ReplayIcon from "@mui/icons-material/Replay";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import NewVersion from "../NewVersionComponent/NewVersion";
import { VERSION } from "../../constants/version";
import { SearchTextField } from "../lib";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import MessageBox from "../shared/components/MessageBox";
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import { useZulassung } from "../../context/zulassungs-context";
import MandantenAuswahl from "../MandantenAuswahl/MandantenAuswahl";
import { ContentCopy } from "@mui/icons-material";
const styles = (theme) => ({
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  },
});
function HomeStandard(props) {
  const { t } = useTranslation();
  const { classes, title, updateTitle, allowedPrograms } = props;
  const [open, setOpen] = useState(false);
  const [activeProgram, setActiveProgram] = useState("");
  const [filter, setFilter] = useState("");
  const [latestVersion, setLatestVersion] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION
  );
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [offeneAufgaben, setOffeneAufgaben] = useSessionStorage(
    LOCAL_STORAGE_KEY.offeneAufgaben
  );
    const [zweiFaGeraet, setZweiFaGeraet] = useState({});
    const [zweiFaMessageBox, setZweiFaMessageBox] = useState(false);
  
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [verteilerHinweisText, setVerteilerHinweisText] = useState(null);
  const [verteilerHinweisTitel, setVerteilerHinweisTitel] = useState(null);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showSuccessMessage,showErrorMessage } = useMessage();
  const { zulassung, updatePrograms, updateMandant } = useZulassung();

  const navigate = useNavigate();

  useEffect(() => {
    if (zulassung.programs.length === 0) {
      fetchPrograms();
    }
  }, []);

  useEffect(() => {
      setFilteredPrograms(zulassung.programs.filter(filterFunction));
      setActiveProgram("");
  }, [filter, zulassung]);

  useEffect(() => {
    if (title !== "") {
      updateTitle("");
    }
    // eslint-disable-next-line
  }, [title]);

  const verteilerCb = (response) => {
    setIsLoading(false);    
    if (response.status === 200) {
      if (response.data.programs) {
        updatePrograms(response.data.programs);
      }
      if (response.data.zweiFaktor) {
        setZweiFaGeraet(response.data.zweiFaktor);    
        setZweiFaMessageBox(true);
      }
      if (response.data.verteilerHinweisText) {
        setVerteilerHinweisText(response.data.verteilerHinweisText);
      }
      if (response.data.verteilerHinweisTitel) {
        setVerteilerHinweisTitel(response.data.verteilerHinweisTitel);
      }
      if (response.data.aufgaben) {
        setOffeneAufgaben(response.data.aufgaben);
      } else {
        setOffeneAufgaben("0");
      }
      setActiveProgram("");
      setLatestVersion(response.data.version);
    } else {
      setIsError(true);
      showErrorMessage(response.data.message);
    }
  };

  const errorCb = (error) => {
    setIsLoading(false);
    setIsError(true);
    console.log("Es konnte keine Verbindung hergestellt werden");
  };

  const fetchPrograms = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setIsLoading(true);
    apiRequest("GET", "verteiler", null, headers, verteilerCb, errorCb);
  };

  const filterFunction = (obj) => {
    if (!obj.name) return false;
    return (
      obj.name.toLowerCase().includes(filter.toLowerCase()) &&
      (allowedPrograms.indexOf(obj.prg) !== -1 || obj.iv)
    );
  };
  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };

  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };

  function messageBoxResult(r) {
    closeMessageBox();
  }

  const handleClientChange = () => {
    const tmpPgm = zulassung.programs.find((pgm) => {
      return(pgm.prg === activeProgram);
    });
      updateTitle(tmpPgm.name);
      navigate("/" + tmpPgm.prg);
  }

  if (isLoading) {
    return (
      <Page>
        <Layout>
          <Toolbar>
            <form className={classes.form}>
              <SearchTextField
                fullWidth
                value={filter}
                label={t("Suche")}
                variant="outlined"
                aria-label="Search"
                onChange={() => console.log("")}
                disabled
              />
            </form>
          </Toolbar>
          <List>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading1">
              <ListItemAvatar>
                <Skeleton
                  variant="circular"
                  animation="wave"
                  width={40}
                  height={40}
                />
              </ListItemAvatar>
              <ListItemText
                primary={<Skeleton variant="text" animation="wave" />}
                secondary={<Skeleton variant="text" animation="wave" />}
              />
            </ListItem>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading2">
              <ListItemAvatar>
                <Skeleton
                  variant="circular"
                  animation="wave"
                  width={40}
                  height={40}
                />
              </ListItemAvatar>
              <ListItemText
                primary={<Skeleton variant="text" animation="wave" />}
                secondary={<Skeleton variant="text" animation="wave" />}
              />
            </ListItem>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading3">
              <ListItemAvatar>
                <Skeleton
                  variant="circular"
                  animation="wave"
                  width={40}
                  height={40}
                />
              </ListItemAvatar>
              <ListItemText
                primary={<Skeleton variant="text" animation="wave" />}
                secondary={<Skeleton variant="text" animation="wave" />}
              />
            </ListItem>
          </List>
        </Layout>
      </Page>
    );
  }
  const displayPrograms =
    zulassung.programs.length > 0 ? (
      filteredPrograms.length > 0 ? (
        filteredPrograms.map((dataObject, count) => {
          const name = dataObject.name;
          const description = dataObject.description;
          if (dataObject.mandanten) {
            if (dataObject.mandanten.length === 1) {
              return (
                <Fragment key={"f" + count.toString()}>
                  <Divider
                    key={"d" + count.toString()}
                    variant="inset"
                    component="li"
                    light
                  />
                  <ListItem
                    key={"v" + count.toString()}
                    button
                    onClick={() => {
                      updateMandant(dataObject.mandanten[0].key);
                      updateTitle(dataObject.name);
                      navigate("/" + dataObject.prg);
                    }}
                  >
                    <ListItemAvatar>
                      <Badge
                        badgeContent={dataObject.notif}
                        color="error"
                        overlap="circular"
                      >
                        <Avatar className={classes.avatar}>
                          {loadMaterialIcon(dataObject.icon)}
                        </Avatar>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText primary={name} secondary={description} />
                  </ListItem>
                </Fragment>
              );
            } else {
              return (
                <Fragment key={"f" + count.toString()}>
                  <Divider
                    key={"d" + count.toString()}
                    variant="inset"
                    component="li"
                    light
                  />
                  <ListItem
                    key={"v" + count.toString()}
                    button
                    onClick={() => {
                      setActiveProgram(dataObject.prg);
                      setOpen(true);
                    }}
                  >
                    <ListItemAvatar>
                      <Badge
                        badgeContent={dataObject.notif}
                        color="error"
                        overlap="circular"
                      >
                        <Avatar className={classes.avatar}>
                          {loadMaterialIcon(dataObject.icon)}
                        </Avatar>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText primary={name} secondary={description} />
                  </ListItem>
                </Fragment>
              );
            }
          } else {
            return (
              <Fragment key={"f" + count.toString()}>
                <Divider
                  key={"d" + count.toString()}
                  variant="inset"
                  component="li"
                  light
                />
                <ListItem
                  key={"v" + count.toString()}
                  button
                  onClick={() =>
                    alert("Sie haben keinen Zugriff auf dieses Programm.")
                  }
                >
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      {loadMaterialIcon(dataObject.icon)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={name} secondary={description} />
                </ListItem>
              </Fragment>
            );
          }
        })
      ) : (
        <Fragment key={"f00"}>
          <Divider key={"d00"} variant="inset" component="li" light />
          <ListItem key={"v00"}>
            <ListItemText
              primary={"Keine Programme gefunden"}
              secondary={"Bitte passen Sie ihre Suche an"}
            />
          </ListItem>
        </Fragment>
      )
    ) : (
      <Fragment key={"f00"}>
        <Divider key={"d00"} variant="inset" component="li" light />
        <ListItem key={"v00"}>
          <ListItemText
            primary={"Herzlich Willkommen in der ectool-App"}
            secondary={
              "Sobald Ihr Account freigeschalten wurde, können Sie hier alle Funktionen der App sehen."
            }
          />
        </ListItem>
      </Fragment>
    );

  if (isError) {
    return (
      <Box p={2}>
        <Typography>{t("Programme konnten nicht geladen werden.")}</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchPrograms}
          startIcon={<ReplayIcon />}
        >
          {t("Erneut versuchen")}
        </Button>
      </Box>
    );
  }
  return (
    <Page>
      <MessageBox
        title={verteilerHinweisTitel}
        text={verteilerHinweisText}
        buttons="OK"
        onClose={closeMessageBox}
        open={messageBoxOpen}
        handleResponse={messageBoxResult}
      />
          <Dialog
              open={zweiFaMessageBox}
              onClose={setZweiFaMessageBox}
              fullWidth
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={{ padding: 4, borderRadius: 2 }}
            >
              <DialogTitle id="alert-dialog-title">
                <Typography variant="h4" sx={{ marginBottom: 2 }}>
                  Sicherheitswarnung
                </Typography>
              </DialogTitle>
              <DialogContent sx={{ padding: 2 }}>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                   Sie haben sich um {zweiFaGeraet?.loginUhrzeit} von einem neuen Gerät: '{zweiFaGeraet?.bez}' angemeldet.
                </Typography>
                <Typography variant="h6" sx={{ marginBottom: 2 }}>
                  Ihr Verifizierungscode lautet:{" "}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
       
                    <Typography variant="h6"  sx={{ fontWeight: 600 }}>
                      {zweiFaGeraet?.code}
                    </Typography>
                      <Tooltip title="TAN kopieren">
                    <IconButton color="primary" onClick={() =>{   navigator.clipboard.writeText(zweiFaGeraet?.code);
        showSuccessMessage("Der TAN wurde in die Zwischenablage kopiert")}}>
                      <ContentCopy />
                    </IconButton>
                    </Tooltip>
                  </Box>
                </Typography>
                <Typography variant="body1" color={""} sx={{ fontWeight: 400 }}>
                  Sollten Sie sich nicht angemeldet haben setzen Sie sich bitte umgehend mit Ihrer Personalabteilung in Verbindung, um Missbrauch mit dem Zugang zu
              vermeiden.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setZweiFaMessageBox(false)} color="primary" variant="contained">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
      {verteilerHinweisText && (
        <Layout fullWidth>
          <Button onClick={openMessageBox} variant="text" color="primary">
            {verteilerHinweisTitel}
          </Button>
        </Layout>
      )}
      <NewVersion latestVersion={latestVersion} />
      <Layout>
        <Toolbar>
          <form className={classes.form}>
            <SearchTextField
              fullWidth
              label={t("Suche")}
              variant="outlined"
              aria-label="Search"
              id="filter"
              value={filter}
              inputProps={{
                autoCapitalize: "off",
                autoCorrect: "off",
                spellCheck: "false",
                autoComplete: "off",
              }}
              onChange={(e) => setFilter(e.target.value)}
            />
          </form>
        </Toolbar>
        <List>{displayPrograms}</List>
        <MandantenAuswahl onClick={handleClientChange} program={activeProgram} open={open} setOpen={setOpen}/>
      </Layout>
    </Page>
  );
}
export default withStyles(styles)(HomeStandard);
